import { computed, signal } from '@preact/signals-core';
import { libraryState } from '../../state';
import { filesSignal } from '../../store/StoreContext';
import { defaultSpace, defaultUser } from '../../types';
import {
  formatBytes,
  formatOutput,
  formatToGB,
  formatToMB,
} from './space_helpers';

const loadingSignal = signal<boolean>(false);

const spaceSignal = computed(() => {
  const session = libraryState.session.value;

  if (!session) return defaultSpace;

  return {
    ...defaultSpace,
    total: { total: session.max_quota || 0 },
    versioning: { total: session.versioning_used_space || 0 },
    used: { total: session.used_space || 0 },
    // Aggiungi altri campi se necessario
  };
});

const userSignal = computed(() => {
  const session = libraryState.session.value;
  if (!session) return defaultUser;

  return {
    commit_count: session.commit_count || 0,
  };
});

const formattedSpaceSignal = computed(() => {
  const space = spaceSignal.value;
  const files = filesSignal.value;
  console.log('🚀 ~ formattedSpaceSignal ~ files:', files);

  return {
    total: formatOutput(space.total.total),
    used: formatOutput(space.used.total),
    versioning: formatOutput(space?.versioning?.total),
    secureinbox: formatOutput(files?.SecureInBox?.totalSize),
    securevault: formatOutput(files?.SecureVault?.totalSize),
    securesync: formatOutput(files?.SecureSync?.totalSize),
    left: {
      bytes:
        space.total.total -
        space.used.total -
        space.versioning.total -
        space.secureinbox.total,
      get formatted() {
        return formatBytes(this.bytes);
      },
      get mb() {
        return formatToMB(this.bytes);
      },
      get gb() {
        return formatToGB(this.bytes);
      },
    },
    leftForUpload: {
      bytes: space.total.total - space.used.total - space.secureinbox.total,
      get formatted() {
        return formatBytes(this.bytes);
      },
      get mb() {
        return formatToMB(this.bytes);
      },
      get gb() {
        return formatToGB(this.bytes);
      },
    },
  };
});

export const useUsedSpace = () => {
  const refresh = async (all_info: boolean) => {
    if (loadingSignal.value) return;
    loadingSignal.value = true;

    try {
      if (all_info) {
        // Implementa qui la logica per ottenere informazioni aggiuntive
      }
    } catch (error) {
      console.error('Error refreshing data', error);
    } finally {
      loadingSignal.value = false;
    }
  };

  const getSecureSyncInfo = () => ({ ...spaceSignal.value.securesync });
  const getSecureVaultInfo = () => ({ ...spaceSignal.value.securevault });
  const getSecureInboxInfo = () => ({ ...spaceSignal.value.secureinbox });
  const getSecurePasswordInfo = () => ({ ...spaceSignal.value.securepassword });

  const getGeneralSpace = () => ({
    total: spaceSignal.value.total.total,
    versioning_space: spaceSignal.value.versioning.total,
    used_space: spaceSignal.value.used.total,
  });

  const getLeftSpace = () => formattedSpaceSignal.value.left.bytes;

  const getLeftSpaceForUpload = () =>
    formattedSpaceSignal.value.leftForUpload.bytes;

  const isNoSpaceLeft = () => spaceSignal.value.no_space_left;

  const getUserCommitCount = () => userSignal.value.commit_count;

  return {
    space: spaceSignal,
    formattedSpace: formattedSpaceSignal,
    user: userSignal,
    refresh,
    getSecureSyncInfo,
    getSecureVaultInfo,
    getSecureInboxInfo,
    getSecurePasswordInfo,
    getGeneralSpace,
    getLeftSpace,
    getLeftSpaceForUpload,
    isNoSpaceLeft,
    getUserCommitCount,
  };
};
